import React, { JSX } from 'react'
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline'

export const ErrorInline = ({
  children,
  onDismiss
}: {
  children: React.ReactNode
  onDismiss?: () => void
}): JSX.Element => (
  <div className='flex items-start gap-2 rounded-md border border-red-500/30 bg-red-500/10 p-3 text-xs text-red-300'>
    <ExclamationTriangleIcon className='size-4 shrink-0' aria-hidden='true' />
    <span className='flex-1'>{children}</span>
    {onDismiss !== undefined && (
      <button
        type='button'
        onClick={onDismiss}
        aria-label='Dismiss'
        title='Dismiss'
        className='-m-1 shrink-0 rounded p-1 text-red-300/70 transition-colors hover:bg-red-500/10 hover:text-red-200'
      >
        <XMarkIcon className='size-3.5' aria-hidden='true' />
      </button>
    )}
  </div>
)
